import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "../../appointmentsPage.module.css";
import { IAppointmentStats, ViewType } from "../../types/appointments.types";

interface IAppointmentStatsProps {
  stats: IAppointmentStats;
  viewType: ViewType;
}

/**
 * Appointment Statistics Component
 *
 * Displays stat cards for appointments overview.
 * Adapts to daily, weekly, or monthly view.
 */
const AppointmentStats: React.FC<IAppointmentStatsProps> = ({
  stats,
  viewType,
}) => {
  return (
    <div className={styles.statsGrid}>
      {/* Total Appointments */}
      <div className={styles.statCard}>
        <div className={styles.statHeader}>
          <span className={styles.statLabel}>
            {viewType === "daily" && t("APPOINTMENTS_TODAY")}
            {viewType === "weekly" && t("APPOINTMENTS_TOTAL_WEEK")}
            {viewType === "monthly" && t("APPOINTMENTS_TOTAL_MONTH")}
          </span>
          <div className={`${styles.statIcon} ${styles.statIconPurple}`}>
            📅
          </div>
        </div>
        <div className={styles.statValue}>
          {viewType === "daily" && stats.totalToday}
          {viewType === "weekly" && stats.totalWeek}
          {viewType === "monthly" && stats.totalMonth}
        </div>
        {/* <div className={`${styles.statChange} ${styles.statChangePositive}`}>
          {viewType === 'daily' && `+3 ${t("APPOINTMENTS_FROM_YESTERDAY")}`}
          {viewType === 'weekly' && `+12% ${t("APPOINTMENTS_FROM_LAST_WEEK")}`}
          {viewType === 'monthly' && `+12% ${t("APPOINTMENTS_FROM_LAST_MONTH")}`}
        </div> */}
      </div>

      {/* Active Therapists */}
      <div className={styles.statCard}>
        <div className={styles.statHeader}>
          <span className={styles.statLabel}>
            {t("APPOINTMENTS_ACTIVE_THERAPISTS")}
          </span>
          <div className={`${styles.statIcon} ${styles.statIconBlue}`}>
            👥
          </div>
        </div>
        <div className={styles.statValue}>
          {stats.activeTherapists}
        </div>
        {/* <div className={styles.statChange}>
          {t("APPOINTMENTS_OF_THERAPISTS", { total: stats.totalTherapists })}
        </div> */}
      </div>
    </div>
  );
};

export default AppointmentStats;
